import React, { useState, useEffect, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import Nav from "./Nav";
import "./ProjectTemplate.css";

const PROJECTS = {
  "fluxaero-os": {
    title: "Example Project A",
    subtitle: "Lorem ipsum dolor sit amet",
    summary:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.",
    tags: ["Lorem", "Ipsum", "Dolor"],
    links: {
      live: "#",
      repo: "#",
    },
    heroNote: "Lorem ipsum dolor sit amet.",
  },
  "cobblemon-toolkit": {
    title: "Example Project B",
    subtitle: "Consectetur adipiscing elit",
    summary:
      "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia.",
    tags: ["Sit", "Amet", "Consectetur"],
    links: {
      live: "#",
      repo: "#",
    },
    heroNote: "Sed do eiusmod tempor incididunt.",
  },
  "fitness-dashboard": {
    title: "Example Project C",
    subtitle: "Sed do eiusmod tempor",
    summary:
      "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.",
    tags: ["Adipiscing", "Elit", "Sed"],
    links: {
      live: "#",
      repo: "#",
    },
    heroNote: "Ut enim ad minim veniam.",
  },
};

export default function ProjectTemplate() {
  const { projectId } = useParams();
  const data = useMemo(() => PROJECTS[projectId], [projectId]);

  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("theme");
    return saved || "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  if (!data) {
    return (
      <div className="app">
        <Nav theme={theme} setTheme={setTheme} />
        <div className="project-wrap">
          <h1 style={{ fontSize: 28, fontWeight: 700, margin: "0 0 10px" }}>Project Not Found</h1>
          <p style={{ color: "var(--text-muted)", margin: "0 0 20px" }}>No project with id "{projectId}".</p>
          <Link to="/" className="project-back">← Back to home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <Nav theme={theme} setTheme={setTheme} />
      <div className="project-wrap">
        <motion.div
          className="project-hero-card"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1>{data.title}</h1>
          <p className="project-subtitle">{data.subtitle}</p>
          <p className="project-blurb">{data.heroNote}</p>
        </motion.div>

        <motion.div
          className="project-section"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <div className="project-card-full">
            <h2 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 10px" }}>Summary</h2>
            <p>{data.summary}</p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 16 }}>
              {data.tags.map((t) => (
                <span key={t} style={{ fontSize: 12, color: "var(--text-muted)", fontWeight: 500 }}>
                  / {t}
                </span>
              ))}
            </div>
            <div style={{ display: "flex", gap: 16, marginTop: 20 }}>
              {data.links.live && (
                <a className="project-back" style={{ margin: 0 }} href={data.links.live} onClick={(e) => e.preventDefault()}>Live</a>
              )}
              {data.links.repo && (
                <a className="project-back" style={{ margin: 0 }} href={data.links.repo} onClick={(e) => e.preventDefault()}>Repo</a>
              )}
              <Link className="project-back" style={{ margin: 0 }} to="/">Back</Link>
            </div>
          </div>
        </motion.div>
      </div>

      <footer className="project-footer">
        <p>&copy; {new Date().getFullYear()} Nameless</p>
        <a href="#" onClick={(e) => e.preventDefault()}>email@example.com</a>
      </footer>
    </div>
  );
}
